import { motion } from "framer-motion";

type BannerProps = {
    title: string;
};

export const Banner = ({ title }: BannerProps) => {
    return (
        <motion.div
            className="flex flex-row items-center w-full bg-background px-4 sm:px-10 py-2"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
        >
            <h3 className="text-white">{title}</h3>
            <span className="h-0.5 w-full ml-2 bg-button" />
        </motion.div>
    );
};
